import { ApplicationDetails } from "../../models/application-details";

export interface ApplicationDetailsState {
  applications: ApplicationDetails[] | null;
  loading: boolean;
  error: any;
  sideNavDetails: any;
}

export const initialState: ApplicationDetailsState = {
  applications: null,
  loading: false,
  error: null,
  sideNavDetails: null
};
